import { render, staticRenderFns } from "./CreateCampaignHeaderGiftsIcon.vue?vue&type=template&id=38c210cd&scoped=true"
import script from "./CreateCampaignHeaderGiftsIcon.vue?vue&type=script&lang=js"
export * from "./CreateCampaignHeaderGiftsIcon.vue?vue&type=script&lang=js"
import style0 from "./CreateCampaignHeaderGiftsIcon.vue?vue&type=style&index=0&id=38c210cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c210cd",
  null
  
)

export default component.exports